// Module
var code = "<div class=\"support-highlights\"><div ng-bind-html=\"$ctrl.highlightsContent\"></div></div>";
// Exports
module.exports = code;